const { getUrlSearchParams } = require('./get-url-search-params')
const { getCookie } = require('../cookies/get-cookie')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @returns {string|undefined}
 */
function getGAClickId () {
  if (typeof window === 'undefined') return
  return getUrlSearchParams()?.gclid || getCookie('gclid') || undefined
}

module.exports = { getGAClickId }
